import { render } from "./vorderlist.vue?vue&type=template&id=17b7c99c&scoped=true"
import script from "./vorderlist.vue?vue&type=script&lang=js"
export * from "./vorderlist.vue?vue&type=script&lang=js"

import "./vorderlist.vue?vue&type=style&index=0&id=17b7c99c&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17b7c99c"]])

export default __exports__